module.exports = __webpack_public_path__ + "img/fopeaInsultosX22.6b3b7724.jpg";